module.exports = __webpack_public_path__ + "svgs/icon_send.2c6ef8be.svg";